import { AfterViewInit, Component, Injector, OnDestroy } from '@angular/core';
import { BaseComponentWithDialog } from "../../admin-panel/base-admin-panel/base-component-with-dialog";
import { GapViewModel } from '../Model/GapViewModel';
import { RacesService } from "../../../services/races.service";

@Component({
    selector: 'app-gap',
    templateUrl: './gap.component.html',
    styleUrls: ['gap.component.css'],
    standalone: false
})
export class GapComponent extends BaseComponentWithDialog implements OnDestroy,AfterViewInit
{
  public gaps: GapViewModel[] = [];
  private racesService: RacesService;
  private interval = null;
  public GapDate: number = (new Date()).getTime();

  constructor(protected injector: Injector)
  {
      super(injector);
      this.racesService = injector.get(RacesService);
  }

  ngAfterViewInit()
  {
    window.dispatchEvent(new CustomEvent("ComponentLoad", { detail: "RaceGap" }));

    //this.interval = setInterval(() => this.Reload(), 3000);
    this.Reload();
  }

  public Reload(): void {
    this.gaps = [];
    this.racesService.getGap(this.GapDate).subscribe(arr => { this.gaps = arr; });
  }

  ngOnDestroy() {
    clearInterval(this.interval);
  }
}
